(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-main-product-v1-0-0"]) return;
  try {
    

(() => {
  if (customElements.get('ze-inline-features-v1')) return;
  class ZEInlineFeatures extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.abort) return;
      this.rail = this.querySelector('.zisf-rail');
      this.cards = Array.from(this.querySelectorAll('.zisf-card'));
      if (!this.rail || !this.cards.length) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const hideMissingScreen = image => {
        if (image && image.matches('.zisf-watch-screen-image')) image.parentElement.hidden = true;
      };
      this.addEventListener('error', event => hideMissingScreen(event.target), {capture: true, signal});
      this.querySelectorAll('.zisf-watch-screen-image').forEach(image => {
        if (image.complete && image.naturalWidth === 0) hideMissingScreen(image);
      });
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-counter]');
      this.progress = this.querySelector('[data-progress]');
      this.status = this.querySelector('[data-status]');
      this.rtl = getComputedStyle(this.rail).direction === 'rtl';
      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('.zisf-arrow svg').forEach(svg => svg.style.transform = this.rtl ? 'rotate(180deg)' : '');
      this.setAttribute('data-enhanced', '');
      this.querySelector('.zisf-controls').hidden = false;
      const progressTrack = this.querySelector('.zisf-progress');
      if (progressTrack) progressTrack.hidden = false;
      this.previous.addEventListener('click', () => this.step(-1), {signal});
      this.next.addEventListener('click', () => this.step(1), {signal});
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => { this.status.textContent = this.rangeText; }, 220);
      }, {passive: true, signal});
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.maxScroll());
        else this.step((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
      }, {signal});
      this.rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,input,select,textarea')) return;
        this.drag = {x: event.clientX, scroll: this.rail.scrollLeft, id: event.pointerId, moved: false};
      }, {signal});
      this.rail.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.rail.classList.add('is-dragging');
          this.rail.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.rail.scrollLeft = this.drag.scroll - delta;
      }, {signal});
      const endDrag = () => {
        if (!this.drag) return;
        const {id, moved} = this.drag;
        this.drag = null;
        if (this.rail.hasPointerCapture(id)) this.rail.releasePointerCapture(id);
        this.rail.classList.remove('is-dragging');
        if (moved) {
          const here = this.position();
          const nearest = this.stops.reduce((a, b) => Math.abs(b - here) < Math.abs(a - here) ? b : a, 0);
          this.go(nearest);
        }
      };
      window.addEventListener('pointerup', endDrag, {signal});
      window.addEventListener('pointercancel', endDrag, {signal});
      window.addEventListener('blur', endDrag, {signal});
      this.rail.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.addEventListener('shopify:block:select', () => this.go(0, true), {signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.rail);
        this.cards.forEach(card => this.observer.observe(card));
      } else window.addEventListener('resize', () => this.measure(), {signal});
      this.measure();
    }
    maxScroll() { return Math.max(0, this.rail.scrollWidth - this.rail.clientWidth); }
    position() { return Math.max(0, Math.min(this.maxScroll(), this.rtl ? -this.rail.scrollLeft : this.rail.scrollLeft)); }
    measure() {
      const first = this.cards[0].getBoundingClientRect();
      const max = this.maxScroll();
      this.cardPositions = this.cards.map(card => {
        const rect = card.getBoundingClientRect();
        return Math.max(0, Math.min(max, this.rtl ? first.right - rect.right : rect.left - first.left));
      });
      this.stops = this.cardPositions.filter((value, index, all) => index === 0 || Math.abs(value - all[index - 1]) > 2);
      if (Math.abs(this.stops[this.stops.length - 1] - max) > 2) this.stops.push(max);
      this.update();
    }
    go(position, instant = false) {
      const target = Math.max(0, Math.min(this.maxScroll(), position));
      this.rail.scrollTo({left: this.rtl ? -target : target, behavior: instant || this.reduceMotion.matches ? 'auto' : 'smooth'});
    }
    step(direction) {
      const here = this.position();
      const target = direction > 0 ? this.stops.find(stop => stop > here + 3) : [...this.stops].reverse().find(stop => stop < here - 3);
      if (target !== undefined) this.go(target);
    }
    update() {
      const here = this.position(), max = this.maxScroll();
      this.previous.disabled = here <= 2;
      this.next.disabled = here >= max - 2;
      const view = this.rail.getBoundingClientRect();
      const visible = this.cards.map((card, index) => {
        const rect = card.getBoundingClientRect();
        const overlap = Math.max(0, Math.min(rect.right, view.right) - Math.max(rect.left, view.left));
        return overlap >= rect.width * .55 ? index + 1 : null;
      }).filter(Boolean);
      const first = visible[0] || 1, last = visible[visible.length - 1] || first;
      this.rangeText = `${first === last ? first : first + '–' + last} ${this.dataset.ofLabel || 'of'} ${this.cards.length}`;
      if (this.counter) this.counter.textContent = this.rangeText;
      if (this.progress) this.progress.style.width = `${max <= 2 ? 100 : ((here + this.rail.clientWidth) / this.rail.scrollWidth) * 100}%`;
      const hint = this.querySelector('.zisf-hint');
      if (hint) hint.hidden = max <= 2;
      this.querySelector('.zisf-controls').hidden = max <= 2;
      const progressTrack = this.querySelector('.zisf-progress');
      if (progressTrack) progressTrack.hidden = max <= 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.statusTimer);
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      this.abort = null;
      this.drag = null;
      if (this.rail) this.rail.classList.remove('is-dragging');
      this.removeAttribute('data-enhanced');
    }
  }
  customElements.define('ze-inline-features-v1', ZEInlineFeatures);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ze-swipe-features"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ze-feature-carousel-v1')) return;
  class ZEFeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.abort) return;
      this.rail = this.querySelector('.zsf-rail');
      this.cards = Array.from(this.querySelectorAll('.zsf-card'));
      if (!this.rail || !this.cards.length) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-counter]');
      this.progress = this.querySelector('[data-progress]');
      this.status = this.querySelector('[data-status]');
      this.rtl = getComputedStyle(this.rail).direction === 'rtl';
      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('.zsf-arrow svg').forEach(svg => svg.style.transform = this.rtl ? 'rotate(180deg)' : '');
      this.setAttribute('data-enhanced', '');
      this.querySelector('.zsf-controls').hidden = false;
      const progressTrack = this.querySelector('.zsf-progress');
      if (progressTrack) progressTrack.hidden = false;
      this.previous.addEventListener('click', () => this.step(-1), {signal});
      this.next.addEventListener('click', () => this.step(1), {signal});
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => { this.status.textContent = this.rangeText; }, 220);
      }, {passive: true, signal});
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.maxScroll());
        else this.step((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
      }, {signal});
      this.rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a,button,input,select,textarea')) return;
        this.drag = {x: event.clientX, scroll: this.rail.scrollLeft, id: event.pointerId, moved: false};
      }, {signal});
      this.rail.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.rail.classList.add('is-dragging');
          this.rail.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.rail.scrollLeft = this.drag.scroll - delta;
      }, {signal});
      const endDrag = () => {
        if (!this.drag) return;
        const {id, moved} = this.drag;
        this.drag = null;
        if (this.rail.hasPointerCapture(id)) this.rail.releasePointerCapture(id);
        this.rail.classList.remove('is-dragging');
        if (moved) {
          const here = this.position();
          const nearest = this.stops.reduce((a, b) => Math.abs(b - here) < Math.abs(a - here) ? b : a, 0);
          this.go(nearest);
        }
      };
      window.addEventListener('pointerup', endDrag, {signal});
      window.addEventListener('pointercancel', endDrag, {signal});
      window.addEventListener('blur', endDrag, {signal});
      this.rail.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.blockId === String(event.detail.blockId));
        if (index !== -1) this.go(this.cardPositions[index], true);
      }, {signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.rail);
        this.cards.forEach(card => this.observer.observe(card));
      } else window.addEventListener('resize', () => this.measure(), {signal});
      this.measure();
    }
    maxScroll() { return Math.max(0, this.rail.scrollWidth - this.rail.clientWidth); }
    position() { return Math.max(0, Math.min(this.maxScroll(), this.rtl ? -this.rail.scrollLeft : this.rail.scrollLeft)); }
    measure() {
      const first = this.cards[0].getBoundingClientRect();
      const max = this.maxScroll();
      this.cardPositions = this.cards.map(card => {
        const rect = card.getBoundingClientRect();
        return Math.max(0, Math.min(max, this.rtl ? first.right - rect.right : rect.left - first.left));
      });
      this.stops = this.cardPositions.filter((value, index, all) => index === 0 || Math.abs(value - all[index - 1]) > 2);
      if (Math.abs(this.stops[this.stops.length - 1] - max) > 2) this.stops.push(max);
      this.update();
    }
    go(position, instant = false) {
      const target = Math.max(0, Math.min(this.maxScroll(), position));
      this.rail.scrollTo({left: this.rtl ? -target : target, behavior: instant || this.reduceMotion.matches ? 'auto' : 'smooth'});
    }
    step(direction) {
      const here = this.position();
      const target = direction > 0 ? this.stops.find(stop => stop > here + 3) : [...this.stops].reverse().find(stop => stop < here - 3);
      if (target !== undefined) this.go(target);
    }
    update() {
      const here = this.position(), max = this.maxScroll();
      this.previous.disabled = here <= 2;
      this.next.disabled = here >= max - 2;
      const view = this.rail.getBoundingClientRect();
      const visible = this.cards.map((card, index) => {
        const rect = card.getBoundingClientRect();
        const overlap = Math.max(0, Math.min(rect.right, view.right) - Math.max(rect.left, view.left));
        return overlap >= rect.width * .55 ? index + 1 : null;
      }).filter(Boolean);
      const first = visible[0] || 1, last = visible[visible.length - 1] || first;
      this.rangeText = `${first === last ? first : first + '–' + last} ${this.dataset.ofLabel || 'of'} ${this.cards.length}`;
      if (this.counter) this.counter.textContent = this.rangeText;
      if (this.progress) this.progress.style.width = `${max <= 2 ? 100 : ((here + this.rail.clientWidth) / this.rail.scrollWidth) * 100}%`;
      const hint = this.querySelector('.zsf-hint');
      if (hint) hint.hidden = max <= 2;
      this.querySelector('.zsf-controls').hidden = max <= 2;
      const progressTrack = this.querySelector('.zsf-progress');
      if (progressTrack) progressTrack.hidden = max <= 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.statusTimer);
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      this.abort = null;
      this.drag = null;
      if (this.rail) this.rail.classList.remove('is-dragging');
      this.removeAttribute('data-enhanced');
    }
  }
  customElements.define('ze-feature-carousel-v1', ZEFeatureCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
